import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { hubspotDealUrl } from "../selectors";

const PRIORITY_LABEL = { high: "Urgent", normal: "To do", low: "Tidy up" };
const PRIORITY_BADGE = {
  high: "pl-badge--bad",
  normal: "pl-badge--info",
  low: "pl-badge--muted",
};

/** A prioritized to-do list, each item linking to its HubSpot deal. */
export function TodoList({ todos, emptyMessage = "Nothing flagged on your pilots right now." }) {
  if (!todos.length) {
    return <div className="pl-empty">{emptyMessage}</div>;
  }

  return (
    <ul className="pl-todos">
      {todos.map((todo) => (
        <li key={todo.id} className="pl-todo">
          <span className={`pl-badge ${PRIORITY_BADGE[todo.priority]}`}>
            {PRIORITY_LABEL[todo.priority]}
          </span>
          <span className="pl-todo-text">
            {todo.text}
            <span className="pl-todo-pilot">{todo.pilotName}</span>
          </span>
          <a
            className="pl-icon-link"
            href={hubspotDealUrl(todo.dealId)}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Open ${todo.pilotName} in HubSpot`}
          >
            <FaExternalLinkAlt aria-hidden="true" />
          </a>
        </li>
      ))}
    </ul>
  );
}
